import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
	syncOptionsContainer: {
		marginTop: '16px',
		marginBottom: '24px',
		padding: '16px',
		borderRadius: '8px',
		backgroundColor: '#fafafa',
		border: '1px solid #e5e7eb'
	},

	siteInputTextarea: {
		width: '100%',
		padding: '12px',
		resize: 'none',
		borderRadius: '8px',
		border: '1px solid #d9d9d9',
		fontSize: '14px',
		marginTop: '8px',
		boxSizing: 'border-box'
	}
});

export default useStyles;
